import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const roomFilterReducer = (state = initialState.roomFilters, action) => {
  switch (action.type) {
    case types.GET_ROOM_FILTERS_SUCCESS:
      return action.payload;
    case types.RESET_ROOM_FILTERS_SUCCESS:
      return [];
    default:
      return state;
  }
};

export const planFilterReducer = (state = initialState.planFilters, action) => {
  switch (action.type) {
    case types.GET_PLAN_FILTERS_SUCCESS:
      return action.payload;

    default:
      return state;
  }
};

export const maxPriceRangeFilterReducer = (
  state = initialState.maxPriceRangeFilter,
  action
) => {
  switch (action.type) {
    case types.GET_MAX_PRICE_FILTERS_SUCCESS:
      return action.payload;

    default:
      return state;
  }
};

export const minPriceRangeFilterReducer = (
  state = initialState.minPriceRangeFilter,
  action
) => {
  switch (action.type) {
    case types.GET_MIN_PRICE_FILTERS_SUCCESS:
      return action.payload;

    default:
      return state;
  }
};

export const hotelFilterReducer = (
  state = initialState.hotelFilter,
  action
) => {
  switch (action.type) {
    case types.SET_HOTEL_FILTERS_SUCCESS:
      return action.payload;

    default:
      return state;
  }
};

export const regionFilterReducer = (
  state = initialState.regionFilter,
  action
) => {
  switch (action.type) {
    case types.SET_REGION_FILTERS_SUCCESS:
      return action.payload;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/filtersReducer.js